import { motion } from "framer-motion";
import {
  InstagramEmbed,
  TikTokEmbed,
} from "react-social-media-embed";

const posts = [
  {
    type: "instagram",
    url: "https://www.instagram.com/reel/DYU09fjN0OG/",
  },
    
      {
        type: "tiktok",
        url: "https://www.tiktok.com/@buildwithpelumi/video/7620483737079287048?is_from_webapp=1&sender_device=pc&web_id=7595179416402970130",
      },

  {
    type: "instagram",
    url: "https://www.instagram.com/reel/DYU09fjN0OG/",
  },
];

const Socials = () => {
  return (
    <section className="bg-[#171718] border-b-2 border-[#7C6AE6] pt-[60px] pb-[60px] md:pt-[100px] lg:pb-[100px] overflow-hidden">
      <div className="mx-auto max-w-[1300px] px-6">

        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8 text-center"
        >
          <h1 className="text-[38px] md:text-[72px] font-semibold uppercase text-white leading-[0.9] tracking-[-0.04em]">
            Content.
            <br />
            <span className="text-white/25 text-[30px]">
              Process. Thoughts.
            </span>
          </h1>
        </motion.div>

        {/* INTRO */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20 max-w-3xl"
        >
          <p className="text-white text-[20px] md:text-[24px] leading-relaxed font-medium">
            I share thoughts around front-end development,
            interface design, product thinking, and the
            real process behind building digital products.
          </p>

          <p className="text-white/55 text-lg leading-relaxed mt-6">
            Most of my content is focused on usability,
            interaction, performance, and the small
            details that shape how people experience products.
          </p>
        </motion.div>

        {/* CONTENT GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

          {posts.map((post, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: i * 0.08,
              }}
              className="
                overflow-hidden
                rounded-[30px]
                border
                border-white/10
                bg-[#1D1D1F]
              "
            >

              {/* TOP BAR */}
              <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">

                <div className="flex items-center gap-3">


                  <div>
                    <p className="text-white text-sm font-semibold">
                      buildwithpelumi
                    </p>

                    <p className="text-white/40 text-[12px] capitalize">
                      {post.type}
                    </p>
                  </div>

                </div>

                <span className="text-white/25 text-sm uppercase">
                  {post.type === "instagram" ? "Reel" : "Video"}
                </span>

              </div>

              {/* EMBED */}
              <div className="bg-black p-3 flex justify-center overflow-hidden">

                <div className="w-full overflow-hidden rounded-[22px]">

                  {post.type === "instagram" ? (
                    <InstagramEmbed
                      url={post.url}
                      width="100%"
                      captioned={false}
                    />
                  ) : (
                    <TikTokEmbed
                      url={post.url}
                      width="100%"
                    />
                  )}

                </div>

              </div>

            </motion.div>
          ))}

        </div>

        {/* CTA */}
        <div className="flex flex-wrap gap-8 mt-16">

          <motion.a
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            href="https://www.instagram.com/buildwithpelumi"
            target="_blank"
            rel="noopener noreferrer"
            className="
              inline-flex
              items-center
              gap-2
              text-[13px]
              font-bold
              uppercase
              tracking-[0.2em]
              text-[#7C6AE6]
              hover:text-white
              transition-colors
            "
          >
            Follow on Instagram →
          </motion.a>

          <motion.a
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            href="https://www.tiktok.com"
            target="_blank"
            rel="noopener noreferrer"
            className="
              inline-flex
              items-center
              gap-2
              text-[13px]
              font-bold
              uppercase
              tracking-[0.2em]
              text-[#7C6AE6]
              hover:text-white
              transition-colors
            "
          >
            Follow on TikTok →
          </motion.a>

        </div>

      </div>
    </section>
  );
};

export default Socials;